module.exports = __webpack_public_path__ + "img/all-together-stake.ac5caa3d.gif";